module.exports = __webpack_public_path__ + "static/media/logo-autosur.58ad04a9.jpg";